import React, { memo } from 'react';
import {metricProgressColor} from '../../../utils/metricProgressColor';

const GoalProgressBar = ({ percentage = 0, color = '', style, title } = props) => {
    const percentageText = percentage != '-1' ? `${percentage}%` : '--';
    percentage = (percentage > 100) ? 100 : (percentage == '-1' ? 0 : percentage);
    let newStyle=  {};
    let boxStyle = {}
    if(style){
      if(style.lineHeight){
        newStyle.lineHeight =  style.lineHeight;
      }
      if(style.marginTop){
        newStyle.marginTop = style.marginTop;
      }
      if(style.fontSize){
        newStyle.fontSize = style.fontSize;
      }
      if(style.width){
        boxStyle.width = style.width
      }
    }
    const aria_label = `${metricProgressColor[color]} ${percentage}%`;
    const aria_minvalue = 0;
    const aria_maxvalue = 100;
    return (
      <>
        <div className="goal-percentage-box" style={boxStyle}>
          <div className="goal-percentage-progress" style = {newStyle} title={title ? title : ""}>
            <div style={{ width: `${percentage}%`, backgroundColor: color }}>&nbsp;</div>
          </div>
        </div>
        <div className="goal-percentage-text" 
         role="progressbar"
         aria-valuenow = {percentage}
         aria-label = {aria_label}
         aria-valuemin = {aria_minvalue} 
         aria-valuemax = {aria_maxvalue}
         style = {newStyle}>{percentageText}</div>
      </>
    );
  };

  export default memo(GoalProgressBar);